/**
 * 平台差异全部收口在这里：
 *   - role：brand（广告主）
 *   - platform：固定 pc（品牌端无 H5 / 移动 Web 形态）
 *   - ModalShell：统一常驻 fixed shell（桌面全屏；与达人端共用组件实现）
 *
 * App.tsx 只需 <TimModal />，对平台细节零感知。
 */
import React from 'react';
import { CloseIcon } from '@/components/icons';
import TimModal from './TimModal';
import ModalShell from './ModalShell';

const BrandTimModal: React.FC = () => (
  <TimModal
    role="brand"
    platform="pc"
    ModalShell={ModalShell}
    closeIcon={<CloseIcon className="w-[16px] h-[16px]" />}
  />
);

export default BrandTimModal;
